import { AnalyticsService } from '@io/services';

import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs';

export class AnalyticsFormControl<T> extends FormControl<T> {
    constructor(
        readonly analyticsService: AnalyticsService,
        readonly key: string,
        readonly value: T
    ) {
        super(value);
        this.sendAnalyticsEvent();
    }

    private sendAnalyticsEvent() {
        this.valueChanges.pipe(skip(1), distinctUntilChanged(), debounceTime(2000)).subscribe((value) => {
            this.analyticsService.sendValueUpdate(this.key, value.toString().toLowerCase());
        });
    }
}
